import React, {useCallback, useEffect, useRef, useState} from "react";
import {CircularProgress} from "@material-ui/core";
import Label from "../../components/label";
import {previouslyPrescribedApiRoute} from "../../apiRoutes";
import MakeAPICall from "../../apiCalls/common";
import PropTypes from "prop-types";
import moment from "moment";

export default function PreviouslyPrescribed(props) {
  const observer = useRef();
  const [pageNo, setPageNumber] = useState(1);
  const [nextPage, setNextPage] = useState(false);
  const [loading, setLoading] = useState(true);
  const [progressBar, setProgressBar] = useState(false);
  const [limit] = useState(10);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [rows, setRows] = useState([]);
  const [appendRows, setAppendRows] = useState([]);

  const lastElementRef = useCallback(node => {
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver(data => {
      if (data) {
        if (data[0].isIntersecting && nextPage && loading) {
          setProgressBar(true);
          setLoading(false);
          if (loading) {
            setPageNumber(pageNo => pageNo + 1);
            let skipDataCalculation = limit * pageNo;
            getPreviouslyPrescribed(limit, skipDataCalculation);
            setRows(rows.concat(appendRows));
          }
          setTimeout(() => {
            setLoading(true);
          }, 2000);
          setTimeout(() => {
            setProgressBar(false);
          }, 1000);
        }
      }
    });
    if (node) observer.current.observe(node);
  });

  const getPreviouslyPrescribed = (limitPage, skipPage) => {
    console.log({previouslyPrescribedApiRoute})
    setApiCallParams({
      reqType: "GET",
      reqURL: previouslyPrescribedApiRoute,
      params: {
        patientEmail: props.email,
        patientID: props.patientID,
        limit,
        skip: skipPage
      },
      successCallback: res => {
        if (skipPage === 0) {
          setRows(res.data.data.drugs);
        } else {
          setAppendRows(res.data.data.drugs);
        }
        if (!res.data.data.drugs.length) {
          setDataLoaded(true);
          setNextPage(false);
        }
        let currentRowCount = res.data.data.count - pageNo * limit;
        currentRowCount > 0 ? setNextPage(true) : setNextPage(false);

        console.log({currentRowCount, data: res.data.data.drugs, skipPage})
      },
      failureCallback: err => {
        console.log("Previously Prescribed API call failed", err);
      },
      showPopUp: false
    });
  };

  useEffect(() => {
    getPreviouslyPrescribed(10, 0)
  }, []);

  function getListItem(data, index) {
    return <div>
      <div className="row">
        <Label title="Date: " className="secondary-font mb-0 font-13"/>
        <Label className="pl-1 mb-0 font-13" title={data.createdAt? moment(data.createdAt).format("DD/MM/YYYY") : "-"}/>
      </div>

      <div className="row">
        <Label title="Drug: " className="secondary-font mb-0 font-13"/>
        <Label
          title={`${data.drugName?.trim()} ${data.strength?.trim()} ${data.formType?.trim()}, ${data.dose?.trim()} ${data.frequency?.trim()} ${data.medTake ? " " + data.medTake : ''}`}
          className="pl-1 mb-0 font-13"/>
      </div>
      <div className="row">
        <Label title="Quantity: " className="secondary-font mb-0 font-13"/>
        <Label title={extractNumberFromMedQty(data.medQuanity)} className="pl-1 mb-0 font-13"/>
      </div>
      <div className="row">
        <Label title="Repeats: " className="secondary-font mb-0 font-13"/>
        <Label title={data.repeat} className="pl-1 mb-0 font-13"/>
      </div>
    </div>
  }

  function extractNumberFromMedQty(val) {
    if (typeof val === "string") {
      let split = val.replace('[', '').split(']');
      if (split.length > 1) {
        return split[0];
      }
    }
    return val;
  }

  return (
    <ul className="m-2 mt-0 list-group list-group-flush border notification-list-ul overflow-auto"
        style={{maxHeight: "250px"}}>
      {rows.map((data, index) => {
        if (rows.length === index + 1) {
          return (
            <li
              className={
                (dataLoaded && !rows.length) ||
                (dataLoaded && rows.length === limit) ||
                (dataLoaded && pageNo > 1)
                  ? "list-group-item"
                  : "list-group-item"
              }
              ref={lastElementRef}
              key={index}>
              { getListItem(data, index) }
            </li>
          );
        } else {
          return (
            <li className="list-group-item" key={index}>
              { getListItem(data, index) }
            </li>
          );
        }
      })}

      {/* Loading   */}

      <li className={progressBar ? "list-group-item text-center p-4" : "d-none"}>
        <CircularProgress disableShrink className="primary-loader"/>
      </li>

      {/*  No data */}

      <li
        className={
          (dataLoaded && !rows.length) ||
          (dataLoaded && rows.length === limit) ||
          (dataLoaded && pageNo > 1)
            ? "list-group-item text-center p-4"
            : "d-none"
        }
      >
        <Label title="No data found" className="w-100 text-center"/>
      </li>
      <MakeAPICall apiParam={apiCallParams}/>
    </ul>
  );
}

PreviouslyPrescribed.propTypes = {
  email: PropTypes.string.isRequired
};
